/** The variant a product page shows. evinitiative.com links to individual
 *  product pages, so /product/:id opens on the variant the id names (Warren,
 *  8 Oct 2026); the family's first variant is only the fallback for an id that
 *  is not one of its variants. A chip the visitor picked wins while it belongs
 *  to the family. */
export function selectedVariantId(
  family: { variants: ReadonlyArray<{ product: { id: string } }> },
  urlId: string,
  chosenId: string | null,
): string {
  const inFamily = (id: string) => family.variants.some((v) => v.product.id === id);
  if (chosenId && inFamily(chosenId)) return chosenId;
  if (inFamily(urlId)) return urlId;
  return family.variants[0]?.product.id ?? urlId;
}
